const PATH = '/signals';

function stringifyFilters (filters) {

    if (!filters) return null;
    if (filters && Object.keys(filters).length === 0) return null;
    return JSON.stringify(filters);
}

export default {
    async getSignals({signals, filters}) {

        filters = stringifyFilters(filters);
        let params = {signals};

        if (filters) params.filters = filters;
        return axios.get(`${PATH}`, {params});
    },
}
